
export interface SandboxSystemFile {
  name: string;
  code: string;
  errors?: string[]; // Validation errors, if any
}

/**
 * A flexible folder structure that can contain:
 * - Root-level files (directly in the folder)
 * - Subfolders with their own files
 */
export interface SandboxFolder {
  /** Files at the root of this folder (e.g., api.ts, types.ts) */
  rootFiles: SandboxSystemFile[];
  /** Subfolders containing files (e.g., systems/, components/, entities/) */
  subfolders: Record<string, SandboxSystemFile[]>;
}

export interface SandboxSystems {
  client: SandboxFolder;
  server: SandboxFolder;
  shared: SandboxFolder;
}

export interface SandboxTemplate {
  name: string;
  description: string;
  systems: SandboxSystems;
}

// Type alias for export functionality
export type SandboxSystemsExport = SandboxSystems;

/**
 * Helper to create an empty folder structure
 */
export function createEmptyFolder(): SandboxFolder {
  return {
    rootFiles: [],
    subfolders: {},
  };
}

/**
 * Helper to create empty systems structure
 */
export function createEmptySystems(): SandboxSystems {
  return {
    client: createEmptyFolder(),
    server: createEmptyFolder(),
    shared: createEmptyFolder(),
  };
}
